<div id="navbar-mobile-container">
    <button class="navbar-mobile-button" (click)="toggleMenu()">
        @if (!isNavbarOpen) {
            <fa-icon icon="bars"></fa-icon>
        } @else {
            <fa-icon icon="close"></fa-icon>
        }
    </button>

    <div id="nav-mobile-logo">
        <a href="/" (click)="closeMenu()">
            <img id="dji-logo" src="assets/dji-logo.svg" width="167px" height="28px" alt="DJI">
        </a>
    </div>




</div>
@if (isNavbarOpen) {
    <app-navbar-mobile-menu (close)="toggleMenu()"></app-navbar-mobile-menu>
}